export enum HRPartyPayingPolicy {
PerCommittee,
PerSession,
}
